import React from "react"
import styled from "styled-components"
import { color } from "../../../components/colors"
import Container from "../../partials/container"
import SectionTitle from "../../atoms/section-title"
import Text from "../../atoms/text"
import Link from "../../atoms/link"
import { FlexBox } from "../../../components/flexbox"
import PhoneSVG from "../../../images/phone.inline.svg"
import MailSVG from "../../../images/mail.inline.svg"
import { typography } from "../../../components/typography"
import Icon from "../../atoms/icon"

const Contact = styled.section`
  padding: 48px 0 0;
  position: relative;

  @media (min-width: 769px) {
    padding: 80px 0;
  }
`

const ContactSection = ({ className, data }) => {
  const { col1 } = data
  const columns = [col1]
  return (
    <Contact id="kontakt" className={className}>
      <Container>
        <SectionTitle
          title="Dane kontaktowe"
          center
          mb="50"
          lineWidth="48px"
          lineCenter
          pb="64px"
        />
        <FlexBox
          column
          directionMD="row"
          justify="space-between"
          mb="24px"
          mbMD="80px"
        >
          {columns.map((column, columnIndex) => (
            <FlexBox
              column
              width="100%"
              widthMD="40%"
              //maxWidthMD="253px"
              mb="20px"
              mbMD="0"
              key={columnIndex}
            >
              {column &&
                column.map((item, index) =>
                  item.fieldtype === "title" ? (
                    <SectionTitle
                      size="3"
                      typography={typography.h400}
                      title={item.fieldtext}
                      pt="0"
                      pb="8px"
                      key={index}
                    />
                  ) : item.fieldtype === "phone" ? (
                    <Link
                      flex
                      href={`tel:${item.fieldtext.replace(/[^\d+]/g, "")}`}
                      color={color.neutral20}
                      mb="8px"
                      noParser
                      key={index}
                    >
                      <Icon icon={<PhoneSVG />} size="22px" mr="10px" />
                      {item.fieldtext}
                    </Link>
                  ) : item.fieldtype === "mail" ? (
                    <Link
                      flex
                      href={`mailto:${item.fieldtext}`}
                      noParser
                      key={index}
                    >
                      <Icon icon={<MailSVG />} size="22px" mr="10px" />
                      {item.fieldtext}
                    </Link>
                  ) : item.fieldtype === "break" ? (
                    <div
                      style={{ marginBottom: item.fieldvalue }}
                      key={index}
                    />
                  ) : (
                    <Text mb="8px" mbMD="16px" key={index}>
                      {item.fieldtext}
                    </Text>
                  )
                )}
            </FlexBox>
          ))}
          <FlexBox width="100%" widthMD="60%" plMD="40px">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2376.4804220782707!2d14.547647341066446!3d53.44199778817989!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47aa09d65717ed7d%3A0x81ae170a05c3b145!2sMi%C5%82osz%20Chr%C3%B3%C5%9Bciak%20Radca%20Prawny%20Szczecin!5e0!3m2!1spl!2sph!4v1783629886464!5m2!1spl!2sph"
              width="600"
              height="450"
              style={{
                position: "relative",
                width: "100%",
                display: "block",
                height: "400px",
                border: "0",
              }}
              allowfullscreen=""
              loading="lazy"
              referrerpolicy="strict-origin-when-cross-origin"
            ></iframe>
          </FlexBox>
        </FlexBox>
      </Container>
    </Contact>
  )
}

export default ContactSection
